const CATEGORIES_ACTION_TYPES = {
  SET_CATEGORIES_MAP: "categories/SET_CATEGORIES_MAP",
  SET_CATEGORIES: "categories/SET_CATEGORIES",
};

export default CATEGORIES_ACTION_TYPES;
